/**
 * ServiceTechnicalDetailsCard — the "Technical Details" card on the Service
 * Detail page. Purely presentational. Extracted from
 * `routes/services/$serviceId.tsx` (issue #1411).
 */
import type { Service } from '../../graphql/types';
import { safeExternalHref } from '../../lib/safeExternalHref';

const CardElement = 'forge-card' as React.ElementType;
const DividerElement = 'forge-divider' as React.ElementType;

/** A stored URL as a link when it is http(s), as text otherwise, or a dash when absent. */
function ExternalLink({ url }: { url?: string | null }): JSX.Element {
  if (!url) {
    return <>—</>;
  }
  const href = safeExternalHref(url);
  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {url}
    </a>
  ) : (
    <>{url}</>
  );
}

export interface ServiceTechnicalDetailsCardProps {
  service: Service;
}

export function ServiceTechnicalDetailsCard({
  service,
}: ServiceTechnicalDetailsCardProps): JSX.Element {
  return (
    <CardElement className="service-card">
      <div className="card-header">
        <h2 className="forge-typography--headline6">Technical Details</h2>
      </div>
      <DividerElement />
      <div className="card-content">
        <div className="detail-row">
          <span className="detail-label">Entity ID</span>
          <span className="detail-value detail-value-code">{service.entityId}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Repository</span>
          <span className="detail-value">
            <ExternalLink url={service.repo} />
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Website</span>
          <span className="detail-value">
            <ExternalLink url={service.url} />
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Schema Version</span>
          <span className="detail-value">{service._schemaVersion}</span>
        </div>
      </div>
    </CardElement>
  );
}
